<app-megamenu></app-megamenu>

<div class="service-page">
  <div class="hero-section">
    <div class="hero-background"></div>
    <div class="container">
      <div class="hero-content">
        <h1>Cockroach Control Services</h1>
        <p class="hero-subtitle">Professional cockroach elimination services. We target all life stages for complete eradication.</p>
        <div class="hero-actions">
          <button mat-raised-button class="cta-button" (click)="navigateToContact()">
            <mat-icon>pest_control</mat-icon>
            Get Cockroach Control
          </button>
          <button mat-button class="phone-button" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Call {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <div class="container">
      <h2>Professional Cockroach Elimination</h2>
      <p>Cockroaches are more than just unsightly - they carry diseases and contaminate food. Our comprehensive cockroach control program eliminates existing infestations and prevents future problems.</p>
      
      <div class="features-grid">
        <div class="feature-card">
          <mat-icon>science</mat-icon>
          <h3>Advanced Baiting Systems</h3>
          <p>Strategic placement of professional-grade baits that eliminate entire colonies</p>
        </div>
        
        <div class="feature-card">
          <mat-icon>shield</mat-icon>
          <h3>Residual Protection</h3>
          <p>Long-lasting treatments that continue working between visits</p>
        </div>
        
        <div class="feature-card">
          <mat-icon>search</mat-icon>
          <h3>Thorough Inspection</h3>
          <p>Complete property assessment to identify all hiding spots and entry points</p>
        </div>
      </div>
    </div>
  </div>

  <div class="cta-section">
    <div class="container">
      <h2>Eliminate Cockroaches Today</h2>
      <p>Don't let cockroaches contaminate your home. Our proven methods eliminate infestations quickly and effectively.</p>
      <button mat-raised-button class="primary-cta" (click)="navigateToContact()">
        <mat-icon>pest_control</mat-icon>
        Schedule Treatment
      </button>
    </div>
  </div>
</div>

<app-footer></app-footer>